export default "__VITE_ASSET__t83ae4mT__"